import React from 'react';
import { ArrowUpRightIcon, MapPinIcon, CheckIcon } from 'lucide-react';
import { ExternalLink } from '../ExternalLink';
import type { Company } from '../../types/company';
type CompanyCardProps = {
  company: Company;
};
export function CompanyCard({
  company
}: CompanyCardProps) {
  const featured = company.featured === true;
  return <article aria-labelledby={`company-${company.rank}`} className={`glass hover-lift rounded-3xl p-6 md:p-8 ${featured ? 'border-aurora-cyan/40' : ''}`} data-id="element-16" data-mp="3shk690xojdfb">
      <div className="flex items-start gap-5" data-id="element-17" data-mp="p020r05dqii2">
        <span className={`font-display text-5xl font-semibold leading-none md:text-6xl ${featured ? 'text-aurora-cyan' : 'text-faint'}`} aria-hidden="true" data-id="element-18" data-mp="ox6197dvvlri">
          {company.rank}
        </span>
        <div className="min-w-0 flex-1" data-id="element-19" data-mp="34r69wy82asex">
          <h3 id={`company-${company.rank}`} className="!mt-0 font-display text-2xl text-ink md:text-[1.75rem]" data-id="element-20" data-mp="34o1zvk7x12gc">
            <span className="sr-only" data-id="element-21" data-mp="c0y323y5bd2s">Number {company.rank}: </span>
            <ExternalLink href={company.url} variant="company" className="hover:text-aurora-cyan" data-id="element-22" data-mp="c1pnqjq7fqea">
              {company.name}
            </ExternalLink>
          </h3>
          <p className="mt-2 flex items-center gap-1.5 text-sm text-faint" data-id="element-23" data-mp="21p1aox1gu5v">
            <MapPinIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-24" data-mp="71l96z8ux5qp" />
            {company.location}
          </p>
        </div>
      </div>

      <div className="mt-6 space-y-4" data-id="element-25" data-mp="3ogrz66rbb5sh">
        {company.summary.map(paragraph => <p key={paragraph.slice(0, 24)} data-id="element-26" data-mp="3t9uv2ljkarbu">{paragraph}</p>)}
      </div>

      <ul aria-label={`${company.name} capabilities`} className="mt-6 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-27" data-mp="3fifz7e4k2vnd">
        {company.capabilities.map(capability => <li key={capability} className="flex items-start gap-2.5 !text-[0.95rem] !leading-6" data-id="element-28" data-mp="35iyup011insz">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aurora-cyan" aria-hidden="true" data-id="element-29" data-mp="3aiabua5bjvb3" />
            {capability}
          </li>)}
      </ul>

      <div className="mt-6 flex flex-col gap-4 border-t border-line pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-30" data-mp="2rf9nt9jwnmxb">
        <p className="!text-[0.95rem] !leading-6" data-id="element-31" data-mp="2ho57o6ihtw0w">
          <strong data-id="element-32" data-mp="2hox6dq7e09ve">Best for:</strong> {company.bestFor}
        </p>
        <ExternalLink href={company.url} variant="company" className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-aurora-cyan hover:text-cyan-200" data-id="element-33" data-mp="2cpkj54clt0sa">
          Visit website
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="35ehmm1c5ot0z" />
        </ExternalLink>
      </div>
    </article>;
}